var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteCirlce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    transform: "rotate(45)",
    viewBox: "0 0 429 442",
    style: {
      enableBackground: "new 0 0 429 442"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#2436E7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 -0.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    className: "st0",
    d: "M214.5,27.3c107.1,0,194,86.8,194,194s-86.8,194-194,194s-194-86.8-194-194 S107.4,27.3,214.5,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_",
    className: "st1",
    d: "M202.4,294v-60.6h-60.6v-24.2h60.6v-60.6h24.2v60.6h60.6v24.2h-60.6V294H202.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCirlce);
export default __webpack_public_path__ + "static/media/white_cirlce.d477b9cd0b6d6a63b6e93a7dcbbf925f.svg";
export { ForwardRef as ReactComponent };